import { useEffect, useState } from 'react';
import Cookie from 'js-cookie';
import { Outlet } from 'react-router-dom';
import Login from '@/Pages/Login/Login';
import ScreenLoader from '@/Shared/ScreenLoader';
import { Targe } from '@/_components/targe';

import { useAppDispatch, useAppSelector } from '@/_store/hooks';
import { COOKIE_TOKEN_KEY, USER_KEY, JSON_KEY } from '@/_constants/keys';
import { setBearerToken } from '@/_config/lib/axios/api-client-old';
import { authLogin } from './_store/modules/auth';
import { selectToken, selectUser } from './_store/modules/auth/selectors';
import { setShowJson } from './_store/modules/layout';
import { normalizeMunicipioIds } from './_utils/normalize-municipio-ids';

function App() {
  const dispatch = useAppDispatch();

  const user = useAppSelector(selectUser);
  const token = useAppSelector(selectToken);

  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getStorage();

    const jsonStorage = localStorage.getItem(JSON_KEY);

    if (jsonStorage) {
      dispatch(setShowJson(true));
    }
  }, []);

  useEffect(() => {
    if (token && user) {
      setLoading(false);
    }
  }, [token, user]);

  const getStorage = async () => {
    const tkStorage = Cookie.get(COOKIE_TOKEN_KEY);
    const userStorage = localStorage.getItem(USER_KEY);

    if (tkStorage && userStorage) {
      setBearerToken(tkStorage);

      const parsedUser = JSON.parse(userStorage);

      dispatch(
        authLogin({
          token: tkStorage,
          user: {
            ...parsedUser,
            municipioIds: normalizeMunicipioIds(parsedUser.municipioIds),
          },
        }),
      );
    } else {
      setLoading(false);
    }
  };

  if (loading) return <ScreenLoader />;
  if (!token || !user) return <Login />;

  return (
    <>
      <Outlet />

      <Targe />
    </>
  );
}

export default App;
